import app from 'flarum/forum/app';
import Modal from 'flarum/components/Modal';
import Button from 'flarum/components/Button';

export default class SiteInfoJoinGroupModal extends Modal {
  static isDismissibleViaBackdropClick = false;
  static isDismissibleViaCloseButton = true;

  oninit(vnode) {
    super.oninit(vnode);
  }

  className() {
    return 'Modal--small';
  }

  title() {
    return (
      <span>
        联系我们
      </span>
    );
  }

  content() {
    const _this = this;
    return (
      <div style="padding:0px 0px 25px 0px" className="Modal-body">
        <div style="text-align: center;">
          <img style="width: 300px;" src="./assets/extensions/ziiven-u2di/joinGroupQR.jpeg" />
        </div>
      </div>
    );
  }
}
